var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectioncompletedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_456",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Section_completed_icon",
    "data-name": "Section completed icon",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Ellipse_456)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_456-2",
    "data-name": "Ellipse 456",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(1.5 0.5)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14162",
    "data-name": "Path 14162",
    d: "M450.315,477.061l-1.972,1.972-1.972-1.972-3.943-3.943,1.972-1.972,3.943,3.943,7.887-7.887,1.972,1.972Z",
    transform: "translate(-434.815 -457.618)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectioncompletedicon);
export default __webpack_public_path__ + "static/media/Section completed icon.514ca877f3a8f3f9f8b5dd1b6ff73343.svg";
export { ForwardRef as ReactComponent };